import React, {useMemo, useState} from 'react';
import {t} from 'i18next';
import {isRTL} from "../../helpers/i18n";
import styled from "styled-components";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {Spin} from "antd";
import {Outlet} from 'react-router-dom'
import useProjectType from "../../helpers/hooks/useProjectType";
import {useDispatch, useSelector} from "react-redux";
import {Header as HeaderText} from "../../styles/globalStyles";
import {LOADING_PAGE, LOADING_PAYMENT} from "@arboxappv4/shared/src/constants/constants";
import Footer from "../../screens/home/Footer";
import useCustomMessage from "../../helpers/hooks/useCustomMessage";
import useLang from "../../helpers/hooks/useLang";
import useKioskStandAloneInitialize from "../../helpers/hooks/useKioskStandAloneInitialize";
import ModalManager from "../../screens/popups/ModalManager";
import useTabName from "../../helpers/hooks/useTabName";
import CountdownTimer from "../../components/CountdownTimer";
import {stepOptions} from "../../flowManager/StepOptions";
import {setOfferInvalidReason} from "@arboxappv4/shared/src/redux/kioskStandAlone/kioskSlice";
import {appointmentWaitlistRejections} from "../../flowManager/steps/appointmentWaitlist/WaitlistHelpers";
import {getHeaderTimer} from "../../flowManager/FlowOptions";

const KioskContainer = (props) => {
    const { } = props;
    const loadingType = useSelector(state => state.kiosk.loadingType)
    const box = useSelector(state => state.kiosk.box)
    const currStep = useSelector(state => state.stepper.currStep)

    const {isMobile} = useScreenSize();
    const dispatch = useDispatch()
    useProjectType({dispatch})
    const {ready} = useLang()
    const customMessageContextHolder = useCustomMessage()
    useKioskStandAloneInitialize({ready})
    useTabName({langReady: ready})

    const width = useMemo(() => !isMobile ? '70%' : '100%', [isMobile])

    if(!ready) return null

    return (
        <Spin spinning={[LOADING_PAGE, LOADING_PAYMENT].includes(loadingType)}>
            <Wrapper direction={isRTL() ? 'rtl' : 'ltr'} className={'site-wrapper'}>
                {customMessageContextHolder}
                <ModalManager/>
                <HeaderDiv isMobile={isMobile}>
                    <HeaderInner width={width}>
                        <HeaderText>{box?.name}</HeaderText>
                        {getHeaderTimer({dispatch})}
                    </HeaderInner>
                </HeaderDiv>
                <Content isMobile={isMobile}>
                    <Outlet context={[width]}/>
                </Content>
                <FooterDiv isMobile={isMobile}>
                    <Footer width={width} showOnlyPoweredBy={isMobile}/>
                </FooterDiv>
            </Wrapper>
        </Spin>
    );
};

export default KioskContainer;


const Wrapper = styled.div`
    background: ${Colors.veryLightGrey}; 
    display: flex;
    height: 100%;
    flex-direction: column;
    direction: ${({direction}) => direction}
`;

const HeaderInner = styled.div`
    width: ${({width}) => width};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

const HeaderDiv = styled.div`
    background: ${Colors.white}; 
    height: ${({isMobile}) => isMobile ? 40 : 60}px;
    justify-content: center;
    display: flex;
    padding: 5px 15px;
    box-shadow: 0px 3px 10px rgba(33, 33, 33, 0.05);
    position: relative;
    align-items: center;
`;

const FooterDiv = styled.div`
    background: ${({isMobile}) => isMobile ? Colors.siteBg : Colors.white}; 
    height: ${({isMobile}) => isMobile ? '25px' : '70px'};
    display: flex;
    justify-content: center;
    padding: 0 ${({isMobile}) => isMobile ? '15px' : 0};
`;

const Content = styled.div`
    display: flex;
    height: calc(100% - ${({isMobile}) => isMobile ? '65px' : '130px'});
    overflow-y: hidden;
    flex-direction: column;
    background-color: ${Colors.siteBg};
    align-items: center;
    padding: ${({isMobile}) => !isMobile ? '0 15px' : 0};
`;